export default __webpack_public_path__ + "static/media/desktop_dr_01.f9da6c21.png";